module.exports = __webpack_public_path__ + "static/media/brain.4b6086de.svg";